import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import FormMailer from "../components/FormMailer";

export default function GroupClassesAdults() {
  return (
    <>
      <Helmet>
        <title>
          Public Speaking Group Classes for Adults | Public Speaking Academy
        </title>
        <meta
          name="description"
          content="Led by Darren Tay, our public speaking training course coaches you effective communication and presentation skills in group. Contact us at 6443 4049 today!"
        ></meta>
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex flex-row justify-between mx-3">
            <div>WORLD CHAMPION CERTIFICATION PROGRAMME</div>
            <div>
              Home / Courses & Programs / Public Speaking for Adults / Regular,
              Weekly Classes
            </div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row pt-5 space-x-10">
            <div class="w-full lg:w-2/3">
              <h1 class="font-primary text-3xl font-bold text-primary uppercase">
                World Champion Certification Programme (Public Speaking classes
                for Adults)
              </h1>
              <h2 class="font-primary text-2xl font-bold text-primary uppercase py-5">
                Regular Group Public Speaking Skills Training for Adults
                (Weekly)
              </h2>
              <div>
                <img src="/images/holiday-programme-1.png" alt="" />
                <p class="py-5 font-text text-lg">
                  Find yourself stumped, doubtful and nervous when asked to
                  deliver a high-stakes business presentation? Having trouble
                  communicating and motivating the team you have just been
                  assigned to lead? Or simply looking for a refreshing take on
                  effective communication skills and networking confidence
                  skills?
                </p>
                <p class="py-5 font-text text-lg">
                  At Public Speaking Academy, we recognise the modern struggle
                  that adults and working professionals face in public speaking,
                  business presentations & communications – indispensable skills
                  in the modern workplace. We believe in lifelong learning and
                  continuous skills upgrading, especially in ensuring that you
                  are not left behind in your fast-paced workplace. True to
                  this, the Public Speaking Academy has designed Singapore’s
                  first{" "}
                  <strong>
                    World Champion public speaking course for adults,
                  </strong>{" "}
                  tailored to meet the contemporary workplace demands. This
                  public speaking training program is designed by our Training
                  team, as led by Darren Tay and registered with the Ministry of
                  Education.
                </p>
                <div className="aspect-video">
                  <iframe
                    class="w-full h-full"
                    src="https://www.youtube.com/embed/CQnUd0r8SYo"
                    title="World Champion Certification Program - Course Intro"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </div>
                <div className="py-5">
                  <p className="py-1 text-xl font-bold">
                    Public Speaking Academy Presents - the World Champion
                    Certification Programme!
                  </p>
                  <p className="py-1 text-xl font-bold">
                    (Public Speaking Academy’s signature presentation course for
                    adults since 2016)
                  </p>
                </div>
                <p className="text-lg font-text">
                  The World Champion Certification Programme is a public
                  speaking course for adults in Singapore designed for working
                  professionals by our first Singaporean World Champion of
                  Public Speaking, Darren Tay, Founder, Managing Director and
                  Master Trainer at the Public Speaking Academy. Tailored for
                  adults and working professionals, the World Champion
                  Certification Program will guide you through an introduction,
                  exploration, and enhancement of public speaking skills and
                  techniques through regular, group training sessions. These
                  consistent, week-in-week-out, engaging and holistic public
                  speaking training classes will help you with:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    <strong>Communications Foundation-Building –</strong>{" "}
                    introduction to necessary foundation skills to enhance your
                    communication and start building your public speaking
                    learning journey (e.g. training classes on body language,
                    pronunciation, enunciation, vocal variety)
                  </li>
                  <li className="text-lg font-text">
                    <strong>
                      Expertise and Techniques for the Modern Communication
                      Settings –
                    </strong>{" "}
                    learn and master relevant and effective communication skills
                    to facilitate the growth of your potential as a confident
                    and charismatic communicator (e.g. training classes on
                    interview skills, PowerPoint presentation skills, persuasive
                    speech)
                  </li>
                  <li className="text-lg font-text">
                    <strong>Constructive and Safe Training Platform –</strong>{" "}
                    providing a safe space for you to grow as a public speaker
                    or effective communicator through practice opportunities,
                    constructive feedback and immediate feedback implementation
                    during every training class throughout the course
                  </li>
                  <li className="text-lg font-text">
                    <strong>Our Learning Methodology –</strong>{" "}
                    Constructively-Challenging & Sufficiently-Safe Learning
                    whereby public speaking theories are imparted in an
                    enthralling way, whilst being dove-tailed with ample
                    practical opportunities throughout the course
                  </li>
                  <li className="text-lg font-text">
                    <strong>
                      Our Qualified team of public speaking experts –
                    </strong>{" "}
                    our{" "}
                    <NavLink
                      className="font-text text-lg text-btnColor hover:underline"
                      to="/senior-trainers-trainers"
                    >
                      World Champion team of trainers
                    </NavLink>{" "}
                    are not recruited through job portals. Our qualified
                    trainers are competitive public speakers and/or presentation
                    trainers prior and are handpicked by our founder{" "}
                    <NavLink
                      className="font-text text-lg text-btnColor hover:underline"
                      to="/master-trainer"
                    >
                      Darren Tay
                    </NavLink>{" "}
                    himself. They are well-versed at our training syllabus and
                    pedagogy, and have shadowed Darren adequately in order to be
                    ready to helm our classes. They are also ACTA-trained and
                    registered with MOE.
                  </li>
                </ul>
                <div>
                  <h3 className="pb-5 font-bold font-primary text-xl py-4 text-center">
                    Course Objectives
                  </h3>
                  <p className="text-lg font-text">
                    At the end of this 9-week{" "}
                    <strong>public speaking skills training course,</strong> you
                    will be able to:
                  </p>
                  <ul className="py-2 px-5 list-disc list-outside">
                    <li className="text-lg font-text">
                      <strong>Confront your insecurities,</strong>{" "}
                      uncertainties, or fear of public speaking as a beginner in
                      various communication settings, and change your
                      relationship with business presentation anxieties
                    </li>
                    <li className="text-lg font-text">
                      <strong>
                        Develop competence in public speaking/ communicating
                        effectively
                      </strong>{" "}
                      before an audience, based on a given context (e.g.,
                      interview, speech, presentation)
                    </li>
                    <li className="text-lg font-text">
                      <strong>
                        Design a speech or presentation based on a given
                        framework,
                      </strong>{" "}
                      scaffold, and/or context (e.g., story-telling, sales
                      pitch)
                    </li>
                    <li className="text-lg font-text">
                      <strong>
                        Display an understanding of body language/non-verbal
                        communication techniques
                      </strong>{" "}
                      while public speaking to any audience, based on a given
                      context
                    </li>
                    <li className="text-lg font-text">
                      <strong>
                        Evaluate your presentation competency levels
                        independently,
                      </strong>{" "}
                      based on speech delivery (e.g., body language), speech
                      content (e.g., crafting content), and speech mindset
                      (e.g., stage fright management)
                    </li>
                  </ul>
                </div>

                <p class="pt-10 pb-5 font-text text-lg">
                  <b>Who should join this public speaking class?</b> World
                  Champion Certification Program (our signature Public Speaking
                  Course for Adults) is perfect for both beginners having their
                  first foray into the public speaking skills training journey
                  and advanced speakers looking to continue their communication
                  and presentation skills development.
                </p>
                <p class="pb-5 font-text text-lg">
                  <b>What can I expect from this course?</b> This training
                  program is conducted as weekly, regular group training
                  classes, with greater emphasis on an encouraging and engaging
                  learning environment. Unlike other one-way lecture-styled
                  courses, our competent and passionate training team delivers a
                  hands-on approach for optimal learning of public speaking
                  skills and presentation techniques – we believe that learning
                  is best achieved through a maximising combination of theory
                  and practice. We provide our students with the printed
                  handouts and video recordings of their practice speech
                  deliveries, maximising their learning by providing them with
                  an opportunity to evaluate their performance in class and
                  identify key areas of improvement moving forward.
                </p>
                <p class="pb-5 font-text text-lg">
                  <b>How big is the class?</b> We keep our class sizes small
                  (maximum 12 students) to ensure that each learner receives
                  dedicated focus and attention to their learning and
                  development from our trainers. You will get the opportunity to
                  review your learning each class in front of a sufficiently
                  challenging group size.
                </p>
                <p class="pb-5 font-text text-lg">
                  We provide our learners with a sufficiently safe, but still
                  constructive, challenging and conducive, training environment
                  for you to learn, train and grow as individuals and as a
                  group. Our public speaking classes are structured based on our
                  50 – 50 Rule:
                </p>
              </div>
              <div className="mx-auto">
                <img src="/images/50-50-Theory.png" alt="" />
              </div>
              <div className="flex flex-row mt-5 lg:space-x-4">
                <div className="p-3 text-lg border-r-2 border-gray-300 border-dashed w-1/2">
                  <p>
                    For every class, 50% of the class time is focused on an open
                    and engaging sharing of public speaking skills and
                    techniques, peppered with our professional trainers’
                    personal experiences and engagement activities & tools.
                  </p>
                </div>
                <div className="p-5 text-lg w-1/2">
                  <p>
                    For every class, 50% of the class time is dedicated to
                    providing our students with the safe and constructive space
                    to practice, practice and practice their craft (ample
                    opportunities to apply the skills taught)! They receive
                    professional, detailed, and dedicated evaluation every
                    training class.
                  </p>
                </div>
              </div>
              <p class="p-5 font-text text-lg">
                Our 50 – 50 Rule ensures that all our learners get a valuable
                opportunity to test their learning in a supportive environment,
                receive immediate and relevant feedback, and clarify their
                doubts in their public speaking learning journey. This prepares
                our learners to apply the experience to other speaking
                opportunities outside!
              </p>

              <div className="w-full bg-slate-100 rounded-xl">
                <div className="pt-10 pb-5">
                  <h2 className="text-xl font-bold text-center font-primary">
                    What Our Adult Learners Have To Say About The Program
                  </h2>
                </div>
                <div className="flex flex-col px-5 md:flex-row">
                  <div className="px-5 pb-10 md:w-1/2">
                    <div className="aspect-video">
                      <iframe
                        class="w-full h-full"
                        src="https://www.youtube.com/embed/ENYBYZDjL2s"
                        title="What Our Students Have To Say • Sebastien Debarge, WCCP Adult Public Speaking Program"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                    </div>
                    <div className="py-2">
                      <p className="font-bold text-md font-primary">
                        Sebastien Debarge,
                      </p>
                      <p className="font-bold text-md font-primary">
                        Working professional (Pharmaceutical industry)
                      </p>
                      <p className="font-bold text-md font-primary">
                        Cohort 2019, WCCP Adult Lvl 1
                      </p>
                    </div>
                  </div>
                  <div className="px-5 pb-10 md:w-1/2">
                    <div className="aspect-video">
                      <iframe
                        class="w-full h-full"
                        src="https://www.youtube.com/embed/B-HWMbKVuxw"
                        title="What Our Students Have To Say • Nigel Eu, WCCP Adult Program"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                    </div>
                    <div className="py-2">
                      <p className="font-bold text-md font-primary">
                        Nigel Eu,
                      </p>
                      <p className="font-bold text-md font-primary">
                        Fresh Graduate
                      </p>
                      <p className="font-bold text-md font-primary">
                        Cohort 2019, WCCP Adult Lvl 1
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col px-5 md:flex-row">
                  <div className="px-5 pb-10 md:w-1/2">
                    <img src="/images/testimonials-1.png" alt="" />
                  </div>
                  <div className="px-5 pb-10 md:w-1/2">
                    <img src="/images/testimonials-2.png" alt="" />
                  </div>
                </div>
                <div className="flex flex-col px-5 md:flex-row">
                  <div className="px-5 pb-10 md:w-1/2">
                    <img src="/images/testimonials-3.png" alt="" />
                  </div>
                  <div className="px-5 pb-10 md:w-1/2">
                    <img src="/images/testimonials-4.png" alt="" />
                  </div>
                </div>
                <div className="flex flex-col px-5 md:flex-row">
                  <div className="px-5 pb-10 md:w-1/2">
                    <img src="/images/testimonials-5.png" alt="" />
                  </div>
                  <div className="px-5 pb-10 md:w-1/2">
                    <img src="/images/testimonials-6.png" alt="" />
                  </div>
                </div>
              </div>

              <div className="my-10">
                <p className="pt-5 pb-5 text-xl italic font-bold">
                  Our Learning Areas and Scope – World Champion Certification
                  Programme (weekly public speaking classes for adults)
                </p>
                <p className="text-lg font-text">
                  The World Champion Certification Programme is designed as a
                  structured and guided learning process to tailor to students
                  from different public speaking background or with nuanced
                  learning objectives. The programme covers general
                  communication skills ranging from body language, vocal variety
                  to advanced public speaking skills/ techniques involving
                  specific speech genres and advanced linguistic skills.
                </p>
              </div>
              <section>
                <div className="py-5">
                  <h2 class="text-center text-4xl font-bold uppercase text-primary italic">
                    COURSE PRICING
                  </h2>
                  <h2 class="text-center text-xl font-bold py-2">
                    World Champion Certification Programme
                  </h2>
                </div>
                <div className="w-full mx-auto md:w-1/2">
                  <div className="py-10 border-2 border-gray-200 rounded-xl">
                    <h2 className="font-bold text-center font-primary">WCCP</h2>
                    <h2 className="py-3 text-4xl font-bold text-center font-primary text-iconColor2">
                      $688
                    </h2>
                    <p className="py-3 text-sm font-bold text-center uppercase font-primary text-primary">
                      Full programme cost (9 lessons)
                    </p>
                    <hr className="w-2/3 h-[3px] mx-auto bg-iconColor1" />
                    <div className="p-14">
                      <ul className="list-disc list-outside">
                        <li className="py-1 text-md font-text">
                          <b>9 weekly</b> lessons (approx. 2 months)
                        </li>
                        <li className="py-1 text-md font-text">
                          <b>Duration:</b> 2 Hours per session
                        </li>
                      </ul>
                    </div>
                    <div className="text-sm font-bold text-center uppercase font-primary text-primary">
                      *no registration fee, no material fee, no GST*
                    </div>
                  </div>
                </div>
              </section>

              <section className="my-10">
                <div className="py-5">
                  <h2 class="text-center text-2xl font-bold py-2">
                    Overview of Topics/ Syllabus
                  </h2>
                  <h3 class="text-center text-2xl font-bold py-2">
                    (Holistic Aspects of Public Speaking Skills Covered)
                  </h3>
                </div>
                <div className="w-full mx-auto md:w-2/3">
                  <div className="p-10 bg-orange-100 border border-orange-200 rounded-2xl">
                    <div>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">
                          CORE FOCUS I: Speech Delivery
                        </b>{" "}
                        (communication techniques to build the foundation you
                        need to create a strong stage impression & confident
                        gloss)
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 1:</b> Body
                        Language Foundation
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 2:</b> Vocal
                        Quality, Variety & Clarity + Linguistic skills
                      </p>
                    </div>

                    <div className="my-3">
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">
                          CORE FOCUS II: Speech Content (Planned)
                        </b>{" "}
                        (speech structures for common communication
                        settings/themes)
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 3:</b>{" "}
                        Story-Crafting & Audience Engagement
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 4:</b>{" "}
                        Informative/Technical Presentations
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 5:</b> Persuasive
                        Presentations
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 6:</b> Presenting
                        with Visual Aids
                      </p>
                    </div>

                    <div className="my-3">
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">
                          CORE FOCUS III: Speech Content (Off-the-Cuff)
                        </b>{" "}
                        (speech techniques for fluid communication
                        settings/themes)
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 7:</b> Impromptu
                        Speech
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 8:</b> Interview
                        Skills (Pitching)
                      </p>
                      <p className="pb-1 text-sm font-primary">
                        <b className="text-purple-700">Session 9:</b>{" "}
                        Edge-of-the-seat Blueprint
                      </p>
                    </div>
                  </div>
                </div>
                <div className="container my-10">
                  <div>
                    <h3 className="font-primary text-xl">
                      Projected Outcomes upon Completion of World Champion
                      Certification Program
                    </h3>
                    <p className="text-lg font-text">
                      (based on feedback from Public Speaking Academy’s past
                      adult learners who have gone through this public speaking
                      skills training program in Singapore):
                    </p>
                    <ul className="py-2 px-5 list-disc list-outside">
                      <li className="text-lg font-text">
                        Enhanced non-verbal communication skills to{" "}
                        <b>
                          speak with greater impact and clarity in the workplace
                        </b>{" "}
                        to facilitate workplace operations, either intra or
                        cross-departmental communications
                      </li>
                      <li className="text-lg font-text">
                        Equipped with actionable public speaking & business
                        presentation skills to{" "}
                        <b>
                          keep the audience engaged, increase knowledge
                          retention
                        </b>{" "}
                        and augmenting the probability of desired actions taken
                        by audience members, within the company/ organization or
                        external stakeholders.
                      </li>
                      <li className="text-lg font-text">
                        Equipped with easy-to-execute impromptu speaking
                        frameworks to be{" "}
                        <b>
                          adequately prepared for spontaneous public speaking
                          settings, internal or public briefings, meetings, Q&A
                        </b>{" "}
                        at seminars etc.
                      </li>
                      <li className="text-lg font-text">
                        Able to{" "}
                        <b>
                          be clear and effective with spoken words and
                          articulation
                        </b>{" "}
                        for greater clarity and impact in presentations and
                        communications
                      </li>
                      <li className="text-lg font-text">
                        Equipped with story-telling techniques to engage your
                        audience and sustain their attention:{" "}
                        <b>Make what you say more persuasive and riveting</b>{" "}
                        (persuasive speaking techniques)
                      </li>
                      <li className="text-lg font-text">
                        Able to lead <b>with Charisma & Eloquence:</b> Using
                        communication skills to influence and charm
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="container my-10">
                  {/* <h2 class="text-primary font-primary font-bold uppercase text-xl md:text-xl text-center py-5">
                    Our Branch Locations
                  </h2> */}
                  <img
                    src="/images/image-of-WCCP-adult-public-speaking-presentation-skills-training-program-schedule-intakes-2.png"
                    className="my-5"
                    alt=""
                  />
                  <p class="text-center py-5">
                    <NavLink
                      className="block font-primary text-white font-bold lg:text-xl text-lg bg-slate-800 hover:bg-slate-500 px-2 lg:px-6 py-2 lg:py-4 rounded-xl"
                      to="https://docs.google.com/document/d/10N6Fv0pUaSMPEaXeMTrh5F0za2WEVVj0P_g9dzdlRYM/edit?usp=sharing"
                    >
                      Enroll Now (Quick 5-min Online Registration)
                    </NavLink>
                  </p>
                  <p class="font-text text-lg md:text-lg  text-textColor py-3">
                    If you would like to request for a customised course timing
                    for your group of friends or colleagues (at Public Speaking
                    Academy’s premises or at your own preferred premises in
                    Singapore), please contact us and indicate your request in
                    the contact form below. We will contact you shortly. Please
                    be informed that we have a minimum class size for a
                    customised course timing.
                  </p>
                  <p class="font-text text-lg md:text-lg  text-textColor py-3">
                    If you are a parent and are also looking for public speaking
                    courses to enrich your kids’ skill-sets, you may check out
                    our{" "}
                    <NavLink
                      to="/group-classes-students-age-7-18/"
                      className="font-text text-lg text-btnColor hover:underline"
                    >
                      public speaking courses for kids here.
                    </NavLink>
                  </p>
                  <div class="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 my-5">
                    <img
                      class="md:w-1/3 w-full h-auto rounded-2xl border-r-4 border-b-4 border-[#FFE4D5]"
                      src="/images/group-classes-for-adults-block-1.jpg"
                      alt=""
                    />
                    <img
                      class="md:w-1/3 w-full h-auto rounded-2xl border-r-4 border-b-4 border-[#FFE4D5]"
                      src="/images/group-classes-for-adults-block-2.jpg"
                      alt=""
                    />
                    <img
                      class="md:w-1/3 w-full h-auto rounded-2xl border-r-4 border-b-4 border-[#FFE4D5]"
                      src="/images/group-classes-for-adults-block-3.jpg"
                      alt=""
                    />
                  </div>
                </div>
                <div>
                  <h2 class="text-primary font-primary font-bold uppercase text-xl md:text-xl text-center py-5">
                    Frequently Asked Questions
                  </h2>
                  <div
                    tabIndex={0}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title">
                      How long is each session?
                    </div>
                    <div className="collapse-content">
                      <p>2 Hours</p>
                    </div>
                  </div>
                  <div
                    tabIndex={1}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title">
                      Who teaches the lessons?
                    </div>
                    <div className="collapse-content">
                      <p>
                        Professional trainer from Darren Tay’s teaching faculty.
                      </p>
                    </div>
                  </div>
                  <div
                    tabIndex={2}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title">
                      What will the class demographics be for this adult public
                      speaking class?
                    </div>
                    <div className="collapse-content">
                      <p>
                        Class demographics is diverse and inclusive. We actually
                        have students from a range of age groups and
                        professional backgrounds, ranging from teens (18-19
                        students), to 20s, to 40s; we have had undergraduates,
                        polytechnic/ junior college studentsas well as retirees.
                        Our student body consists of a whole range of
                        occupations: newly-hired, mid-level managers, sales
                        agents, self-employed, nurses, teachers, company
                        executives etc. (Communication skills are needed in
                        every single industry - which is why our student
                        demographics are pretty diverse 😊👍).
                      </p>
                    </div>
                  </div>
                  <div
                    tabIndex={3}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title">
                      How is payment done?
                    </div>
                    <div className="collapse-content">
                      <p>
                        Upon confirmation and registration of participant (via
                        the receipt of the completed registration form),
                        participant will make full payment of the program fee in
                        order to secure the his/ her seat.
                      </p>
                      <p>
                        Payment can be made through the following modes:
                        <br />
                        1. PayNow
                        <br />
                        2. Fund Transfer
                        <br />
                        3. PayPal (for credit card payments)
                      </p>
                    </div>
                  </div>
                  <div
                    tabIndex={2}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title">
                      What if I miss a lesson?
                    </div>
                    <div className="collapse-content">
                      <p>
                        We do not have any lessons on designated public
                        holidays. However, for any reason that you cannot make
                        it for lessons on regular lesson days, fret not.
                        Although we do not have a replacement class policy, we
                        will assist you in your learning and ensure that you
                        will not be left behind by helping you in 2 areas:
                        <br />
                        1. We offer you all the notes and materials used by the
                        trainer during the lesson which you missed.
                        <br />
                        2. We offer you our online training video(s), featuring
                        our World Champion of Public Speaking, Darren Tay, for
                        the respective lesson(s) missed.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="px-5 pt-5 my-20 mb-10 border border-gray-400 border-dashed rounded-lg">
                  <h3 className="pb-2 text-2xl font-bold text-center font-primary text-primary">
                    To register, please fill up the contact form below and we
                    will process your registration for you.
                  </h3>
                  <FormMailer />
                </div>
              </section>

              <div className="bg-slate-50 p-2 md:p-10 ">
                <div className=" mb-10">
                  <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                    END OF COURSE DETAILS
                  </h1>
                  <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                    Quick Tips
                  </h1>
                </div>

                <div
                  tabIndex={0}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧠 How to Improve Presentation Skills
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      <b>Presentation skills</b> refer to your ability to
                      clearly, confidently, and effectively share information
                      with an audience. Engagement techniques form a core aspect
                      of presentation skills.
                    </p>
                    <p className="py-1">
                      Whether you’re in a meeting, on stage, or online, here are
                      simple ways to level up:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Structure your message
                      </p>
                      <p className="font-text">
                        Use a clear beginning, middle, and end. Start with a
                        hook, dive into key points, and wrap with a strong
                        takeaway. Clarity is King, Delivery is Queen.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Practice aloud
                      </p>
                      <p className="font-text">
                        Rehearsing out loud helps build fluency and uncover weak
                        spots. Record yourself or present to a friend. You may
                        receive feedback from your viewers thereafter.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Mind your body language
                      </p>
                      <p className="font-text">
                        Stand tall, make eye contact, and use open gestures.
                        Your body speaks even when your mouth doesn’t. Other
                        aspects of body language include stage positioning,
                        facial expressions and body language leakages.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Speak with intention
                      </p>
                      <p className="font-text">
                        Pace yourself, pause for impact, and emphasize key
                        words. Don’t rush—clarity matters more than speed.
                        Speaking with intention also helps with reducing the use
                        of pause fillers.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">5. Get feedback</p>
                      <p className="font-text">
                        Ask a trusted colleague or coach for honest,
                        constructive input.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={1}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    😰 How to Overcome Fear of Public Speaking
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Fear of public speaking is common—it’s often rooted in a
                      fear of judgment or making mistakes.
                    </p>
                    <p className="py-1">To manage it effectively:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Prepare thoroughly
                      </p>
                      <p className="font-text">
                        Knowing your material well builds confidence. Use
                        sign-posts throughout the speech to internalize its
                        structure well.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Visualize success
                      </p>
                      <p className="font-text">
                        Shift your focus from negativity to picturing yourself
                        speaking calmly and clearly. Mental rehearsal matters.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">3. Start small</p>
                      <p className="font-text">
                        Speak up in small meetings or practice with friends
                        before tackling bigger stages.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Focus on your audience
                      </p>
                      <p className="font-text">
                        “Big Baby Pivot” – treating your audience as a “big
                        baby” that requires your full attention, instead of
                        focusing on yourself, shift it to how you can help or
                        inform others.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Breathe and pause
                      </p>
                      <p className="font-text">
                        Take deep breaths (inhale while feeling the coolness of
                        the air, and exhale with pursed lips). Pausing helps you
                        think and eases nerves. Pause with sustained eye contact
                        to enhance the impact of your pauses.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={2}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🗣️ How to Speak Clearly and Professionally
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      To speak clearly and professionally means expressing your
                      ideas in a way that’s easy to follow and leaves a good
                      impression.
                    </p>
                    <p className="py-1">Here’s how to do it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">1. Slow down</p>
                      <p className="font-text">
                        Speaking too fast can confuse your audience. Aim for a
                        natural pace. Moderate rate of speaking is about 2-3
                        words per second.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Enunciate words
                      </p>
                      <p className="font-text">
                        Practice crisp, clear pronunciation—especially of key
                        terms.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Trim the fillers
                      </p>
                      <p className="font-text">
                        Reduce "um", "like", and "you know". Silence is better
                        than a filler.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Use simple language
                      </p>
                      <p className="font-text">
                        Big words aren’t impressive if they cause confusion.
                        Clarity wins.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Practice vocal variety
                      </p>
                      <p className="font-text">
                        Change your tone and pitch to avoid sounding flat or
                        robotic.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={3}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧩 How to Organize a Speech Quickly
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      When time is tight, a solid structure saves the day. Use
                      the tried-and-true <b>“Point, Reason, Example”</b> format.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Start with your point
                      </p>
                      <p className="font-text">
                        What’s the key message or takeaway? One thing that even
                        if your audience forgets everything else BUT this!
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Add your reason
                      </p>
                      <p className="font-text">
                        Why does it matter? Back it up with logic or context.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Give an example
                      </p>
                      <p className="font-text">
                        Stories or real-life applications make your message
                        stick.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Close with a recap
                      </p>
                      <p className="font-text">
                        Reinforce your main point and end confidently.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={4}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧑💼 How to Speak Confidently in Meetings & Interviews
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Speaking up in meetings is a professional skill that can
                      boost your visibility and influence.
                    </p>
                    <p className="py-1">Try this approach:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Prepare your points in advance
                      </p>
                      <p className="font-text">
                        Jot down key ideas or questions you want to raise, with
                        full prior knowledge of the agenda of the day.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Look for open moments
                      </p>
                      <p className="font-text">
                        Chime in after someone finishes, or use phrases like “To
                        add to that…”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">3. Start small</p>
                      <p className="font-text">
                        Comment on one idea or ask one question. You don’t need
                        to <b>dominate</b>, instead, you <b>initiate</b> a new
                        conversation!
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Use confident language
                      </p>
                      <p className="font-text">
                        Avoid undermining yourself with phrases like “I might be
                        wrong but…”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Practice regularly
                      </p>
                      <p className="font-text">
                        The more you speak, the more natural it becomes.
                        Repetition/ Stage mileage is the killer of stage fright.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={5}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧩 What Are Effective Public Speaking Techniques for Sales
                    Professionals
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Sales professionals rely on strong speaking skills to
                      build trust and close deals.
                    </p>
                    <p className="py-1">
                      Here’s how to speak more persuasively in sales settings:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Focus on the listener's needs
                      </p>
                      <p className="font-text">
                        Start with their pain points—not your product. Frame
                        your message as a solution (instead of harping on
                        features, focus on benefits; e.g. the AI-assisted app
                        feature can save 30% time and cost, boosting
                        productivity) .
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Use clear, benefit-driven language
                      </p>
                      <p className="font-text">
                        Explain how your product helps in real-world terms.
                        Avoid jargon.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Tell client success stories
                      </p>
                      <p className="font-text">
                        Share short, authentic testimonials of how others
                        benefited.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practice objection handling
                      </p>
                      <p className="font-text">
                        Stay calm when prospects push back—acknowledge, decipher
                        underlying concerns, answer, and refocus.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Project confidence and energy
                      </p>
                      <p className="font-text">
                        Your tone (reassuring), posture (ready to serve), and
                        sustained eye contact all help build rapport.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧑🏫 Public Speaking Tips for Educators
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Whether you're in a classroom or on stage, educators need
                      to keep people engaged and informed.
                    </p>
                    <p className="py-1">
                      Here’s how to level up your speaking:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Start with a strong hook
                      </p>
                      <p className="font-text">
                        Open with a question (hand raised to arouse students’
                        participation), image, or fact to draw learners in.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Break ideas into chunks
                      </p>
                      <p className="font-text">
                        Use structure and transitions to guide understanding.
                        Use sign-posts to boost knowledge retention – “Having
                        dealt with the challenges we face, we now move on to the
                        solutions!”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Vary your tone and pace
                      </p>
                      <p className="font-text">
                        Keep things lively—avoid monotone delivery. Firm when
                        delivering facts and challenges ahead, vigorous when
                        delivering future plans!
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Engage with questions
                      </p>
                      <p className="font-text">
                        Ask, pause, and invite responses to keep attention.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Use stories to explain concepts
                      </p>
                      <p className="font-text">
                        Real-life analogies and classroom anecdotes make lessons
                        stick. “Facts tell, Stories sell.”
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={8}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💼 Public Speaking Tips for Self-Employed Professionals
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Entrepreneurs, freelancers, and solo practitioners often
                      pitch, network, and lead—all through communication.
                    </p>
                    <p className="py-1">
                      Here’s how to make your voice work for your brand:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Sharpen your elevator pitch
                      </p>
                      <p className="font-text">
                        Be ready with a clear, confident intro of who you help
                        and how (stand out by portraying yourself as a problem
                        solver).
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Create content with your voice
                      </p>
                      <p className="font-text">
                        Webinars, podcasts, or workshops let you show expertise
                        and build trust.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Share your story
                      </p>
                      <p className="font-text">
                        Your journey matters—use it to connect with audiences
                        and clients.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Learn to pitch persuasively
                      </p>
                      <p className="font-text">
                        Structure, delivery (talking about the product/
                        service’s benefits instead of features), and
                        call-to-action are key in proposals and presentations.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Show up consistently
                      </p>
                      <p className="font-text">
                        Your tone, posture, and messaging should align across
                        all platforms.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={9}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💬 How to Prepare for a Job Interview (and Stand Out)
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Doing well in an interview isn’t just about answering
                      questions—it’s about showing you’re the right fit.
                    </p>
                    <p className="py-1">Here’s how to prepare:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Know the job inside out
                      </p>
                      <p className="font-text">
                        Read the job description carefully. Match your skills to
                        what they’re looking for.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Practice common questions
                      </p>
                      <p className="font-text">
                        Rehearse answers to “Tell me about yourself,” “What are
                        your strengths?” or “Why should we hire you?”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Use the 5W 1H method
                      </p>
                      <p className="font-text">
                        Structure answers with{" "}
                        <b>
                          What (the situation), Why (importance), How
                          (solution), When (review actions at the end)
                        </b>
                        —great for behavioral/ hypothetical questions.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Prepare thoughtful questions
                      </p>
                      <p className="font-text">
                        Show interest by asking about the team, growth
                        opportunities, or company values.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Mind your body language
                      </p>
                      <p className="font-text">
                        Smile, make eye contact, and sit upright. Non-verbal
                        cues matter just as much as words.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={10}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎯 Communication Skills Training for Managers and Team
                    Leaders
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Strong communication helps leaders motivate, align, and
                      build trust with their teams.
                    </p>
                    <p className="py-1">Key areas to develop:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Clarity of message
                      </p>
                      <p className="font-text">
                        Leaders should exercise economy of words – always strive
                        for clarity and conciseness.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Active listening
                      </p>
                      <p className="font-text">
                        Hear your team out— discover underlying concerns and
                        then respond with empathy and relevance.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Giving feedback
                      </p>
                      <p className="font-text">
                        Offer constructive feedback that contains actionable
                        steps that support progress, not just correction or
                        worse, condemnation.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Speaking with presence
                      </p>
                      <p className="font-text">
                        Your voice, tone, and body language should project calm
                        and confidence.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Handling tough conversations
                      </p>
                      <p className="font-text">
                        Training helps leaders stay composed and fair—even under
                        pressure.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={11}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🚀 How to Improve Executive Presence for Career Advancement
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Executive presence is about how you carry yourself—your
                      communication, confidence, and credibility.
                    </p>
                    <p className="py-1">Here’s how to grow it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Speak with structure
                      </p>
                      <p className="font-text">
                        Clear, organized messages reflect strong thinking. E.g.
                        Speech flow: Situation – Task – Action – Result
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Control your tone and pace
                      </p>
                      <p className="font-text">
                        A calm yet firm, even voice inspires confidence.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Manage reactions under stress
                      </p>
                      <p className="font-text">
                        Staying composed during pressure-cooker moments builds
                        trust.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Lead with vision
                      </p>
                      <p className="font-text">
                        Use persuasive communication to align people around
                        goals and ideas, by sharing the purpose behind those
                        goals, and how they can benefit from the goals achieved.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Get feedback on your presence
                      </p>
                      <p className="font-text">
                        Mentors or coaches can point out blind spots.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={12}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧠 How to Handle Difficult Questions in Business
                    Presentations
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Tough questions during a presentation can feel
                      intimidating—but they’re actually a chance to show
                      credibility and calm under pressure.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Stay calm and listen fully
                      </p>
                      <p className="font-text">
                        Don’t interrupt. Take a breath to process before you
                        reply.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Clarify if needed
                      </p>
                      <p className="font-text">
                        If the question is vague or aggressive, reframe it:
                        “Just to clarify—are you asking about…?”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Acknowledge the concern
                      </p>
                      <p className="font-text">
                        A simple “That’s a valid point” shows respect and
                        professionalism despite any disagreement with the
                        argument.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Answer concisely
                      </p>
                      <p className="font-text">
                        Stick to facts. If you don’t know, it’s okay to say:
                        “I’ll check on that and get back to you.”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Redirect to your main message
                      </p>
                      <p className="font-text">
                        Bring the audience back to your key takeaway: “The KEY
                        point I’m trying to make is…”
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎯 Presentation Skills Training Course for Adults
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      <b>A presentation skills training course for adults</b>{" "}
                      helps professionals communicate clearly, confidently, and
                      persuasively—whether in meetings, on stage, or online. It
                      should offer a deep-dive into public speaking and business
                      presentation techniques, tailored to the modern working
                      adult.
                    </p>
                    <p className="py-1">
                      Here’s what a good presentation course typically covers:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Building speaking confidence
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            Teaches effective power poses you can use to
                            overcome stage fright and business presentation
                            anxieties.
                          </li>
                          <li className="list-disc">
                            Guides students through step-by-step visualization
                            method to be consistently confident in public
                            speaking settings.
                          </li>
                          <li className="list-disc">
                            How to rehearse & practice like the top professional
                            speakers.
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Structuring a compelling presentation
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            How to compose an attention-grabbing story
                          </li>
                          <li className="list-disc">
                            The secrets to delivering powerful powerpoint
                            presentation without reading off the slides
                          </li>
                          <li className="list-disc">
                            The "8-step Edge of the seat" formula that keeps
                            peoples listening attentively plus 2 speech genres
                            (persuasive and informative speech)
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Improving vocal delivery and body language
                      </p>
                      <p className="font-text">
                        Have adult learners practice eye contact, tone
                        variation, gestures, and posture to create presence.
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            Hand gestures,power poses, stage positioning fright
                          </li>
                          <li className="list-disc">
                            How to have stage presence with proper eye contact
                            (learn about the wide angle of attack and eye
                            contact distribution)
                          </li>
                          <li className="list-disc">
                            The power of incorporating pauses in your
                            presentation
                          </li>
                          <li className="list-disc">
                            Facial expressions you should avoid using
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practising with real exposure to unfamiliar audience
                      </p>
                      <p className="font-text">
                        Deliver speeches in breakout sessions & final showcase
                        to accumulate stage mileage, in front of classmates from
                        all walks of life, get insightful trainer’s feedback,
                        and apply techniques in work-related contexts.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Personalized feedback/ evaluation
                      </p>
                      <p className="font-text">
                        The best presentation skills training programs offer
                        personalized guidance and evaluation to help you improve
                        & develop faster.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden lg:inline lg:w-1/3 px-5 pt-5 mb-10 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
